// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2oUAT","subTitle":"styles_subTitle__2XlZi","skip":"styles_skip__AcV2I","tipImg":"styles_tipImg__PMU6r"};